import get from 'lodash/get';
import {
  FETCH_ALL_ZONES,
  FETCH_MARKET_ZONES,
  ZONES_LOADING,
} from '../actions/zones';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_ALL_ZONES:
      return {
        ...state,
        zones: action.payload,
      };
    case FETCH_MARKET_ZONES: {
      const zones = get(action, 'payload', []);
      const noDynamicZones = zones.filter((zone) => !get(zone, 'isDynamic', false));
      return {
        ...state,
        marketZones: zones,
        noDynamicZones,
      };
    }
    case ZONES_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
